import { render, staticRenderFns } from "./InviteeDetails.vue?vue&type=template&id=18b04a47"
import script from "./InviteeDetails.vue?vue&type=script&lang=js"
export * from "./InviteeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports